import ExportButtonWithLoader from '@creditflowresearch/uilib/ExportButtonWithLoader';
import { useBondsAssetClassesContext } from '@/creditflowresearch/application/Bonds/BondsAssetClassesContext';
import { useFiltersContext } from '@/creditflowresearch/application/FiltersContext';
import { useBondsContext } from '@/creditflowresearch/application/Bonds/BondsContext';
import { useBondsFiltersContext } from '@/creditflowresearch/application/Bonds/BondsFiltersContext';
import { useExportBondsToExcel } from '@/creditflowresearch/application/Bonds/useExportBondsToExcel';

interface IProps {
  dataTest?: string,
}

const ExportToExcelButtonContainer = ({ dataTest }: IProps) => {
  const { isFetching, exportToExcel } = useExportBondsToExcel();
  const { currentAssetClass } = useBondsAssetClassesContext();
  const {
    bwicsData: { bwics: { totalCount: bwicCount } },
    inventoriesData: { inventories: { totalCount: inventoryCount } },
  } = useBondsContext();
  const { params: { search } } = useFiltersContext();
  const { filtersPayload } = useBondsFiltersContext();

  const isDisabled = !(bwicCount || inventoryCount);

  return (
    <ExportButtonWithLoader
      onClick={ () => exportToExcel({ assetClassId: currentAssetClass?.id, search, filtersPayload }) }
      isFetching={ isFetching }
      isDisabled={ isDisabled }
      tooltipContent="Export to Excel"
      disabledTooltipContent="Export to Excel not available"
      buttonSize="S"
      dataTest={ dataTest }
      ariaLabel="Export to Excel"
    />
  );
};

export default ExportToExcelButtonContainer;
